module.exports = __webpack_public_path__ + "img/logogsy.d40f4ebf.jpg";